
// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/loan/loanEmiSlice";
// import { payLoanEmi , payLoanEmiNew} from "../redux/slices/loan/PayLoanEmiSlice";
// import jsPDF from "jspdf";
// import "../assets/Loan/GroupLoanEmiDetails.css";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import axios from "axios";

// const GroupLoanEmiDetails = () => {
//   const { loanId } = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const loan = location.state?.loan;
//   const [emis,setemis]=useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [count,setcount]=useState(0);

//   const { length,loading, error } = useSelector(
//     (state) => state.loanEmi
//   );

//   const { profile } = useSelector((state) => state.userProfile);

//   const [company, setCompany] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedEmi, setSelectedEmi] = useState(null);
//   const [paymentData, setPaymentData] = useState({
//     type: "full",
//     amountPaid: "",
//     paymentMode: "Cash",
//     paymentDate: new Date().toISOString().split("T")[0],
//     remark:""
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);
//   const [showPreview, setShowPreview] = useState(false);

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // Fetch EMI + company info
//   useEffect(() => {
//     // if (loanId) dispatch(fetchLoanEmis(loanId));

//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(
//           `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
//         );
//         const data = await res.json();
//         if (res.ok && data) {
//           if (data.logo)
//             data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(
//               /^images\//,
//               ""
//             )}`;
//           setCompany(data);
//         }
//       } catch (err) {
//         console.error("Failed to fetch company details", err);
//       }
//     };
//     fetchemis();
//     if (profile?.superAdminId) fetchCompany();

//     // return () => {
//     //   dispatch(clearLoanEmis());
//     // };
//   }, [loanId, dispatch, profile?.superAdminId]);

//   const fetchemis = async (page = currentPage) => {
//       try {
//         const res = await axios.get(
//           `https://narrowitsolution.in/api/group-loan/emi/list`, {
//              params: {
//               superAdminId:profile.superAdminId,
//               branchId:loan.branchId,
//               grouploanAccountId:loan.id,
//               page,
//               limit:10,
//             }
//         });
  
//          console.log("emis data", res);
//         setemis(res.data?.data || []);
//         setTotalPages(res.data.pagination.totalPages || 1);
//         setcount(res.data.pagination.totalRecords)
//       } catch (err) {
//         console.error("Fetch Error:", err);
//       }
//     };
  

//   useEffect(()=> {
//     fetchemis();
//   },[currentPage])

//   // 🟢 Payment Type Handler
//   const handlePayClick = (emi, type) => {
//     setSelectedEmi(emi);

//     let defaultAmount = emi.emiAmount;
//     if (type === "partial") defaultAmount = "";
//     if (type === "advance") defaultAmount = emi.emiAmount;

//     setPaymentData({
//       type,
//       amountPaid: defaultAmount,
//       paymentMode: "Cash",
//       paymentDate: new Date().toISOString().split("T")[0],
//     });

//     setShowModal(true);
//   };

 
//   // const handleSubmitPayment = async () => {
//   // if (!selectedEmi) return;

//   // try {
//   //     setSubmitting(true);

//   //     const payload = {
//   //     emiId:selectedEmi.id,
//   //     paidAmount: paymentData.amountPaid,
//   //     paymentMode: paymentData.paymentMode,
//   //     paidDate: paymentData.paymentDate,
//   //     collectedBy:7,
//   //     remark:paymentData.remark,
//   //     };

//   //     let resultAction;

//   //     // 1️⃣ FULL EMI → OLD API
//   //     if (paymentData.type === "full") {
//   //     resultAction = await dispatch(payLoanEmi(payload));
//   //     }

//   //     // 2️⃣ PARTIAL + ADVANCE → NEW API
//   //     else if (paymentData.type === "partial" || paymentData.type === "advance") {
//   //       resultAction = await dispatch(
//   //       payLoanEmiNew({
//   //           ...payload,
//   //           paymentType: paymentData.type,   // <---- ADD THIS
//   //       })
//   //       );
//   //     }

//   //     if (
//   //     payLoanEmi.fulfilled.match(resultAction) ||
//   //     payLoanEmiNew.fulfilled.match(resultAction)
//   //     ) {
//   //     alert(`✅ ${resultAction.payload.message}`);
//   //     setShowModal(false);
//   //     setSelectedEmi(null);
//   //     dispatch(fetchLoanEmis(loanId));
//   //     } else {
//   //     alert("❌ Payment failed");
//   //     }
//   // } finally {
//   //     setSubmitting(false);
//   // }
//   // };

//   const handleSubmitPayment= async () => {
//     if (!selectedEmi) return;

//       const payload = {
//         emiId:selectedEmi.id,
//         paidAmount: paymentData.amountPaid,
//         paymentMode: paymentData.paymentMode,
//         paidDate: paymentData.paymentDate,
//         collectedBy:profile.id,
//         remark:paymentData.remark,
//       };

//     try 
//       {
//          await axios.post(`https://narrowitsolution.in/api/group-loan/emi/pay`, payload); 
//          alert("payment successfull");
//       }
//      catch 
//      {
//        alert("❌ Payment failed");
//      }
//     fetchemis();
//     setShowModal(false);
//   }


//   const formatDate = (d) =>
//     d ? new Date(d).toLocaleDateString() : "-";

//   const formatCurrency = (n) =>
//     `Rs. ${Number(n || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 2,
//     })}`;

//   // PDF + Slip Helpers
//   const loadLogoAsDataURL = (src) =>
//     new Promise((resolve) => {
//       if (!src) return resolve(null);
//       const img = new Image();
//       img.crossOrigin = "anonymous";
//       img.onload = () => {
//         try {
//           const canvas = document.createElement("canvas");
//           canvas.width = img.width;
//           canvas.height = img.height;
//           canvas.getContext("2d").drawImage(img, 0, 0);
//           resolve(canvas.toDataURL("image/png"));
//         } catch {
//           resolve(null);
//         }
//       };
//       img.onerror = () => resolve(null);
//       img.src = src;
//     });


//   const buildEmiSlipPDF = async (emi, serialNo) => {
//     const doc = new jsPDF({ unit: "pt", format: "a4" });

//     const isPaidOrPartial =
//         (emi.status || "").toLowerCase() === "paid" ||
//         (emi.status || "").toLowerCase() === "partial";

//     if (!isPaidOrPartial) {
//         alert("Slip available only for PAID or PARTIAL EMIs");
//         return null;
//     }

//     const pageWidth = doc.internal.pageSize.getWidth();
//     const margin = 40;

//     // Load logo
//     const logoDataURL = await loadLogoAsDataURL(
//         company?.logoUrl || "/techvisionlogo.jpg"
//     );

//     // ------------------------------
//     // HEADER
//     // ------------------------------
//     if (logoDataURL)
//         doc.addImage(logoDataURL, "PNG", margin, margin, 65, 65);

//     doc.setFont("helvetica", "bold").setFontSize(20);
//     doc.text(
//         company?.name || "TechVision Finance",
//         margin + 80,
//         margin + 20
//     );

//     doc.setFont("helvetica", "normal").setFontSize(11);
//     doc.text(
//         `Email: ${company?.email || ""} | Phone: ${company?.contact || ""}`,
//         margin + 80,
//         margin + 40
//     );

//     // Title
//     doc.setFontSize(15).setFont("helvetica", "bold");
//     doc.text("EMI Payment Slip", margin, margin + 90);

//     let y = margin + 120;

//     // ------------------------------
//     // BASIC INFO
//     // ------------------------------
//     const infoLeft = [
//         ["Customer Name",loan.memberName],
//         ["Loan No", loan.loanAccountNumber],
//         ["EMI No", emi.installmentNo],
//     ];

//     const infoRight = [
//         // ["Payment Mode", emi.paymentMode || "-"],
//         ["Paid Date", formatDate(emi.paidDate)],
//         ["Due Date", formatDate(emi.dueDate)],
//     ];

//     doc.setFontSize(12).setFont("helvetica", "bold");

//     infoLeft.forEach(([label, value], idx) => {
//         doc.text(`${label}:`, margin, y + idx * 18);
//         doc.setFont("helvetica", "normal");
//         doc.text(String(value || "-"), margin + 120, y + idx * 18);

//         doc.setFont("helvetica", "bold");
//     });

//     infoRight.forEach(([label, value], idx) => {
//         doc.text(`${label}:`, pageWidth / 2, y + idx * 18);
//         doc.setFont("helvetica", "normal");
//         doc.text(String(value || "-"), pageWidth / 2 + 120, y + idx * 18);

//         doc.setFont("helvetica", "bold");
//     });

//     y += 80;

//     // ------------------------------
//     // EMI INFO
//     // ------------------------------
//     const emiInfo = [
//         ["EMI Amount",  emi.emiAmount?.toFixed(2)],
//         ["Status", emi.status],
//     ];

//     emiInfo.forEach(([label, val], idx) => {
//         doc.setFont("helvetica", "bold").text(label, margin, y + idx * 20);
//         doc.setFont("helvetica", "normal").text(val, pageWidth / 2, y + idx * 20);
//     });

//     y += 60;

//     // ------------------------------
//     // PREMIUM PARTIAL PAYMENTS TABLE
//     // ------------------------------
//     let partialPayments = [];

//     for (let i = 1; i <= 5; i++) {
//         if (emi[`payment${i}`] > 0) {
//         partialPayments.push({
//             amount: emi[`payment${i}`],
//             date: emi[`payment${i}Date`],
//             mode: emi[`payment${i}Mode`] || "-",
//         });
//         }
//     }

//     if (partialPayments.length > 0) {
//         doc.setFont("helvetica", "bold").setFontSize(14);
//         doc.text("Partial Payments", margin, y);
//         y += 20;

//         const tableX = margin;
//         const colW = [40, 110, 140, 100];
//         const rowH = 20;

//         // HEADER
//         doc.setFont("helvetica", "bold").setFontSize(11);
//         const headers = ["No", "Amount", "Paid Date", "Mode"];

//         let x = tableX;
//         headers.forEach((h, idx) => {
//         doc.text(h, x, y);
//         x += colW[idx];
//         });

//         y += 8;

//         // line
//         doc.setLineWidth(0.8);
//         doc.line(tableX, y, tableX + colW.reduce((a, b) => a + b), y);
//         y += 15;

//         // ROWS
//         doc.setFont("helvetica", "normal").setFontSize(11);

//         partialPayments.forEach((p, i) => {
//         let colX = tableX;
//         const values = [
//             `${i + 1}`,
//             p.amount.toFixed(2),
//             formatDate(p.date),
//             p.mode,
//         ];

//         values.forEach((v, idx) => {
//             doc.text(v, colX, y);
//             colX += colW[idx];
//         });

//         y += rowH;
//         });

//         y += 15;
//     }

//     // ------------------------------
//     // OUTSTANDING
//     // ------------------------------
//     doc.setFont("helvetica", "bold").setFontSize(13);
//     doc.text("Outstanding Balance:", margin, y);
//     doc.setFont("helvetica", "normal");
//     doc.text((emi.outstanding?.toFixed(2) || "0.00"), pageWidth / 2, y);

//     y += 50;

//     // ------------------------------
    

//     // ------------------------------
//     // FOOTER
//     // ------------------------------
//     doc.setFont("helvetica", "italic").setFontSize(10);
//     doc.text(
//         "This is a system-generated EMI Slip. No signature required.",
//         margin,
//         y
//     );

//     return doc;
//     };


//   const generateEmiSlipPDF = async (emi, serialNo) => {
//         const doc = await buildEmiSlipPDF(emi, serialNo);
//         if (!doc) return;
//         doc.save(`EMI_Slip_${loan.loanAccountNumber}_EMI${emi.installmentNo || serialNo}.pdf`);
//     };

//   const previewEmiSlipPDF = async (emi, serialNo) => {
//     const doc = await buildEmiSlipPDF(emi, serialNo);
//     if (!doc) return;
//     const blob = doc.output("blob");
//     const url = URL.createObjectURL(blob);
//     setPreviewUrl(url);
//     setShowPreview(true);
//    };

//   if (loading) return <p>Loading EMI Schedule...</p>;
//   if (error) return <p>Error: {error}</p>;

//   return (
//     <div className="viewemiloandata-container">
//       {/* Header */}
//       <header className="viewemiloandata-headerbar">
//         <div className="viewemiloandata-company">
//           <img
//             src={company?.logoUrl || "/techvisionlogo.jpg"}
//             alt="Company Logo"
//             className="viewemiloandata-logo"
//           />
//           <div className="viewemiloanddata-company-details">
//             <h2 className="viewemiloandata-companyname">
//               {company?.name || "TechVision Finance"}
//             </h2>
//             {/* <p>{company?.tagline || "Trusted Loan Partner"}</p> */}
//             <p>
//               <strong>Email:</strong> {company?.email} 
//             </p>
//             <p>
//               <strong>Phone:</strong> {company?.contact}
//             </p>
//           </div>
//         </div>
//       </header>

//       {/* Loan Info */}
//       <div className="viewemiloandata-loaninfo">
//         <h3>Loan & Customer Details</h3>
//         <p>
//           <strong>Customer:</strong> {loan.memberName}
//         </p>
//         <p>
//           <strong>Loan No:</strong> {loan.loanAccountNumber}
//         </p>
//         <p>
//           <strong>Total EMIs:</strong> {count}
//         </p>
//       </div>

//       {/* EMI Table */}
//       <div className="viewemiloandata-table-container">
//         <h3>Loan EMI Schedule</h3>

//         {emis.length === 0 ? (
//           <p>No EMIs found</p>
//         ) : (
//           <table className="viewemiloandata-table">
//             <thead>
//               <tr>
//                 <th>EMI No</th>
//                 <th>Due Date</th>
//                 <th>Amount</th>
//                 <th>Status</th>
//                 <th>Paid Date</th>
//                 <th>Action</th>
//                 <th>Slip</th>
//               </tr>
//             </thead>

//             <tbody>
//               {emis.map((emi, i) => {
//                 const isPaid = emi.status?.toLowerCase() === "paid";
//                 const isPartial = emi.status?.toLowerCase() === "partial";
//                 const isPending = emi.status?.toLowerCase() === "pending";

//                 return (
//                   <tr
//                     key={emi.id}
//                     className="emi-row"
//                     style={{
//                       background: isPaid
//                         ? "#e8f7e8"
//                         : isPartial
//                         ? "#fff6e0"
//                         : "#ffecec",
//                     }}
//                   >
//                     <td>{emi.emiNumber||emi.installmentNo}</td>

//                     <td>{formatDate(emi.dueDate)}</td>

//                     <td>
//                       {formatCurrency(emi.emiAmount)}

//                       <div className="emi-small">
//                         <span>Principal: {formatCurrency(emi.principalComponent)}</span>
//                         <br />
//                         <span>Interest: {formatCurrency(emi.interestComponent)}</span>
//                       </div>
//                     </td>

//                     <td style={{ fontWeight: "bold" }}>
//                       {isPaid && <span style={{ color: "green" }}>Paid</span>}
//                       {isPartial && <span style={{ color: "#ff9800" }}>Partial</span>}
//                       {isPending && <span style={{ color: "red" }}>Pending</span>}

//                       {/* partial details */}
//                       {isPartial && (
//                         <div className="emi-small">
//                           Paid: {formatCurrency(emi.partiallyPaidAmount)} <br />
//                           Remaining: {formatCurrency(emi.emiBalance)}
//                         </div>
//                       )}

//                       {/* last payment details */}
//                       {isPaid && emi.lastPaidAmount && (
//                         <div className="emi-small">
//                           Last Paid: {formatCurrency(emi.lastPaidAmount)}
//                         </div>
//                       )}

//                       {/* outstanding */}
//                       <div className="emi-small">
//                         Outstanding: {formatCurrency(emi.outstanding)}
//                       </div>
//                     </td>

//                     <td>{emi.paidDate ? formatDate(emi.paidDate) : "-"}</td>

//                     {/* ACTIONS */}
//                     <td>
//                       {isPaid ? (
//                         <span style={{ color: "green", fontWeight: "bold" }}>✔ Paid</span>
//                       ) : (
//                         <div className="emi-actions">
//                           <button className="btn-full" onClick={() => handlePayClick(emi, "full")}>
//                             Pay 
//                           </button>

//                           {/* <button className="btn-partial" onClick={() => handlePayClick(emi, "partial")}>
//                             Partial
//                           </button> */}

//                           {/* <button className="btn-advance" onClick={() => handlePayClick(emi, "advance")}>
//                             Advance
//                           </button> */}
//                         </div>
//                       )}
//                     </td>

//                     {/* Slip */}
//                     <td>
//                       {isPaid ? (
//                         <div classname="slip-action-button-grploan">
//                           <button
//                             className="btn-print"
//                             onClick={() => generateEmiSlipPDF(emi, i + 1)}
//                           >
//                             Download
//                           </button>
//                           <button
//                             className="btn-preview"
//                             onClick={() => previewEmiSlipPDF(emi, i + 1)}
//                           >
//                             Preview
//                           </button>
//                         </div>
//                       ) : (
//                         <span style={{ color: "gray" }}>After Payment</span>
//                       )}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>

//           </table>
//         )}
//       </div>

//       {/* Payment Modal */}
//       {showModal && (
//         <div className="viewemiloandata-modal-overlay">
//           <div className="viewemiloandata-modal">
//             <h3>
//               {paymentData.type === "full" &&
//                 `Pay Full EMI (No: ${selectedEmi?.emiNumber})`}
//               {paymentData.type === "partial" &&
//                 `Partial Payment (No: ${selectedEmi?.emiNumber})`}
//               {paymentData.type === "advance" &&
//                 `Advance EMI Payment (No: ${selectedEmi?.emiNumber})`}
//             </h3>

//             {paymentData.type === "partial" && (
//               <p style={{ color: "red", fontWeight: "bold" }}>
//                 Note: Partial payment accepted. Remaining amount will stay
//                 pending.
//               </p>
//             )}

//             <label>
//               Amount:
//               <input
//                 type="number"
//                 value={paymentData.amountPaid}
//                 onChange={(e) =>
//                   setPaymentData({
//                     ...paymentData,
//                     amountPaid: e.target.value,
//                   })
//                 }
//               />
//             </label>

//             <label>
//               Mode:
//               <select
//                 value={paymentData.paymentMode}
//                 onChange={(e) =>
//                   setPaymentData({
//                     ...paymentData,
//                     paymentMode: e.target.value,
//                   })
//                 }
//               >
//                 <option value="Cash">Cash</option>
//                 <option value="Card">Card</option>
//                 <option value="UPI">UPI</option>
//                 <option value="NetBanking">Net Banking</option>
//               </select>
//             </label>

//             <label>
//               Date:
//               <input
//                 type="date"
//                 value={paymentData.paymentDate}
//                 onChange={(e) =>
//                   setPaymentData({
//                     ...paymentData,
//                     paymentDate: e.target.value,
//                   })
//                 }
//               />
//             </label>

//             <label>
//               Remark:
//               <input
//                 type="text"
//                 value={paymentData.remark}
//                 onChange={(e) =>
//                   setPaymentData({
//                     ...paymentData,
//                     remark: e.target.value,
//                   })
//                 }
//               />
//             </label>

//             <div className="modal-actions">
//               <button onClick={() => setShowModal(false)}>Cancel</button>

//               <button
//                 onClick={handleSubmitPayment}
//                 disabled={submitting}
//               >
//                 {submitting ? "Processing..." : "Confirm"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Preview Modal */}
//       {showPreview && previewUrl && (
//         <div className="viewemiloandata-modal-overlay">
//           <div
//             className="viewemiloandata-modal"
//             style={{ width: "80%", height: "90%" }}
//           >
//             <h3>Slip Preview</h3>

//             <iframe
//               src={previewUrl}
//               style={{
//                 width: "100%",
//                 height: "80%",
//                 border: "none",
//               }}
//             />

//             <div className="modal-actions">
//               <button
//                 onClick={() => {
//                   setShowPreview(false);
//                   URL.revokeObjectURL(previewUrl);
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="account-ledger-list-pagination-section">
//             <div className="account-ledger-list-pagination-div">
//               <button
//                 onClick={() => setCurrentPage(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 ⬅ Prev
//               </button>

//               <span>
//                 Page {currentPage} of {totalPages}
//               </span>

//               <button
//                 onClick={() => setCurrentPage(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               >
//                 Next ➡
//               </button>
//             </div>
//          </div>

//       {/* Footer */}
//       <footer className="viewemiloandata-footer">
//         <p>© 2025 {company?.name || "TechVision Finance"} Pvt. Ltd.</p>
//         <p>{company?.tagline || "Empowering Dreams"}</p>
//       </footer>

      
//     </div>
//   );
// };

// export default GroupLoanEmiDetails;







/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import jsPDF from "jspdf";
import "../assets/Loan/GroupLoanEmiDetails.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const GroupLoanEmiDetails = () => {
  const { loanId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const loan = location.state?.loan;

  const [emis, setemis] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setcount] = useState(0);

  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [paymentData, setPaymentData] = useState({
    amountPaid: "",
    paymentMode: "Cash",
    paymentDate: new Date().toISOString().split("T")[0],
    remark: "",
  });

  const [previewUrl, setPreviewUrl] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    fetchemis();
    if (profile?.superAdminId) fetchCompany();
  }, [loanId, profile?.superAdminId]);

  useEffect(() => {
    fetchemis();
  }, [currentPage]);

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
      );
      const data = await res.json();
      if (data?.logo) {
        data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
      }
      setCompany(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchemis = async (page = currentPage) => {
    try {
      // const res = await axios.get(`https://narrowitsolution.in/api/group-loan/emi/list`, {
      const res = await axios.get(`https://narrowitsolution.in/api/group-loan/emi/list-filter`, {
        params: {
          superAdminId: profile.superAdminId,
          branchId: loan.branchId,
          grouploanAccountId: loan.id,
          page,
          limit: 10,
        },
      });

      console.log('emis data',res.data)
      setemis(res.data?.data || []);
      setTotalPages(res.data.totalPages || 1);
      setcount(res.data.totalRecords || 0);
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ FULL PAYMENT ONLY
  const handlePayClick = (emi) => {
    setSelectedEmi(emi);
    setPaymentData({
      amountPaid: emi.emiAmount,
      paymentMode: "Cash",
      paymentDate: new Date().toISOString().split("T")[0],
      remark: "",
    });
    setShowModal(true);
  };

  const handleSubmitPayment = async () => {
    if (!selectedEmi) return;

    try {
      setSubmitting(true);

      const payload = {
        emiId: selectedEmi.id,
        paidAmount: paymentData.amountPaid,
        paymentMode: paymentData.paymentMode,
        paidDate: paymentData.paymentDate,
        collectedBy: profile.id,
        remark: paymentData.remark,
      };

      await axios.post(`https://narrowitsolution.in/api/group-loan/emi/pay`, payload);
      toast.success("✅ Payment Successful");
      fetchemis();
      setShowModal(false);
    } catch {
      toast.error("❌ Payment Failed");
    } finally {
      setSubmitting(false);
    }
  };

  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString("en-GB") : "-";

  const formatCurrency = (n) =>
    `Rs. ${Number(n || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
    })}`;

  // ---------- PDF ----------
  const loadLogoAsDataURL = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });

 const buildEmiSlipPDF = async (emi) => {
  if ((emi.status || "").toLowerCase() !== "paid") {
    toast.warn("Slip available only for PAID EMI");
    return null;
  }

  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 40;

  // Load Logo
  const logoDataURL = await loadLogoAsDataURL(
    company?.logoUrl || "/techvisionlogo.jpg"
  );

  /* ================= HEADER ================= */
  if (logoDataURL) {
    doc.addImage(logoDataURL, "PNG", margin, margin, 65, 65);
  }

  doc.setFont("helvetica", "bold").setFontSize(20);
  doc.text(
    company?.name || "TechVision Finance",
    margin + 80,
    margin + 22
  );

  doc.setFont("helvetica", "normal").setFontSize(11);
  doc.text(
    `Email: ${company?.email || "-"} | Phone: ${company?.contact || "-"}`,
    margin + 80,
    margin + 42
  );

  doc.setFont("helvetica", "bold").setFontSize(15);
  doc.text("EMI Payment Slip", margin, margin + 95);

  let y = margin + 125;

  /* ================= CUSTOMER / LOAN INFO ================= */
  const leftInfo = [
    ["Customer Name", loan.memberName],
    ["Loan Account No", loan.loanAccountNumber],
    ["EMI No", emi.installmentNo],
  ];

  const rightInfo = [
    ["Paid Date", formatDate(emi.paidDate)],
    ["Due Date", formatDate(emi.dueDate)],
    ["Payment Mode", emi.payment1Mode || "-"],
  ];

  doc.setFontSize(12).setFont("helvetica", "bold");

  leftInfo.forEach(([label, value], i) => {
    doc.text(`${label}:`, margin, y + i * 20);
    doc.setFont("helvetica", "normal");
    doc.text(String(value || "-"), margin + 130, y + i * 20);
    doc.setFont("helvetica", "bold");
  });

  rightInfo.forEach(([label, value], i) => {
    doc.text(`${label}:`, pageWidth / 2, y + i * 20);
    doc.setFont("helvetica", "normal");
    doc.text(String(value || "-"), pageWidth / 2 + 130, y + i * 20);
    doc.setFont("helvetica", "bold");
  });

  y += 80;

  /* ================= EMI DETAILS ================= */
  const emiDetails = [
    ["EMI Amount", formatCurrency(emi.emiAmount)],
    ["Payment Status", emi.status],
  ];

  emiDetails.forEach(([label, value], i) => {
    doc.setFont("helvetica", "bold");
    doc.text(label, margin, y + i * 22);
    doc.setFont("helvetica", "normal");
    doc.text(String(value || "-"), pageWidth / 2, y + i * 22);
  });

  y += 60;

  /* ================= OUTSTANDING ================= */
  doc.setFont("helvetica", "bold").setFontSize(13);
  doc.text("Outstanding Balance:", margin, y);
  doc.setFont("helvetica", "normal");
  doc.text(
    formatCurrency(emi.outstanding || 0),
    pageWidth / 2,
    y
  );

  y += 50;

  /* ================= FOOTER ================= */
  doc.setFont("helvetica", "italic").setFontSize(10);
  doc.text(
    "This is a system-generated EMI slip. No signature required.",
    margin,
    y
  );

  return doc;
};


  const generateEmiSlipPDF = async (emi) => {
    const doc = await buildEmiSlipPDF(emi);
    if (doc) doc.save(`EMI_Slip_${loan.loanAccountNumber}_${emi.installmentNo}.pdf`);
  };

  const previewEmiSlipPDF = async (emi) => {
    const doc = await buildEmiSlipPDF(emi);
    if (!doc) return;
    const url = URL.createObjectURL(doc.output("blob"));
    setPreviewUrl(url);
    setShowPreview(true);
  };

  // if (loading) return <p>Loading EMI Schedule...</p>;
  // if (error) return <p>Error: {error}</p>;

  return (
    <div className="viewemiloandata-container">
      {/* Header */}
      <header className="viewemiloandata-headerbar">
        <div className="viewemiloandata-company">
          <img
            src={company?.logoUrl || "/techvisionlogo.jpg"}
            alt="Company Logo"
            className="viewemiloandata-logo"
          />
          <div className="viewemiloanddata-company-details">
            <h2 className="viewemiloandata-companyname">
              {company?.name || "TechVision Finance"}
            </h2>
            {/* <p>{company?.tagline || "Trusted Loan Partner"}</p> */}
            <p>
              <strong>Email:</strong> {company?.email} 
            </p>
            <p>
              <strong>Phone:</strong> {company?.contact}
            </p>
          </div>
        </div>
      </header>

      {/* Loan Info */}
      <div className="viewemiloandata-loaninfo">
        <h3>Loan & Customer Details</h3>
        <p>
          <strong>Customer Name:</strong> {loan.memberName}
        </p>
        <p>
          <strong>Loan Account No:</strong> {loan.loanAccountNumber}
        </p>
        <p>
          <strong>Total EMIs:</strong> {count}
        </p>
        {/* <p>
          <strong>Scheme Name:</strong> {loan.schemeName}
        </p> */}
      </div>

      {/* EMI Table */}
      <div className="viewemiloandata-table-container">
        <h3>Loan EMI Schedule</h3>

        {emis.length === 0 ? (
          <p>No EMIs found</p>
        ) : (
          <table className="viewemiloandata-table">
            <thead>
              <tr>
                <th>EMI No</th>
                <th>Due Date</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Paid Date</th>
                <th>Action</th>
                <th>Slip</th>
              </tr>
            </thead>

            <tbody>
              {emis.map((emi, i) => {
                const isPaid = emi.status?.toLowerCase() === "paid";
                const isPartial = emi.status?.toLowerCase() === "partial";
                const isPending = emi.status?.toLowerCase() === "pending";
                const nextEmi = i < emis.length - 1 ? emis[i + 1] : null;
                return (
                  <tr
                    key={emi.id}
                    className="emi-row"
                    style={{
                      background: isPaid
                        ? "#e8f7e8"
                        : isPartial
                        ? "#fff6e0"
                        : "#ffecec",
                    }}
                  >
                    <td>{emi.emiNumber||emi.installmentNo}</td>

                    <td>{formatDate(emi.dueDate)}</td>

                    <td>
                      {formatCurrency(emi.emiAmount)}

                      <div className="emi-small">
                        <span>Principal: {formatCurrency(emi.principalComponent)}</span>
                        <br />
                        <span>Interest: {formatCurrency(emi.interestComponent)}</span>
                      </div>
                    </td>

                    <td style={{ fontWeight: "bold" }}>
                      {isPaid && <span style={{ color: "green" }}>Paid</span>}
                      {isPartial && <span style={{ color: "#ff9800" }}>Partial</span>}
                      {isPending && <span style={{ color: "red" }}>Pending</span>}

                      {/* partial details */}
                      {isPartial && (
                        <div className="emi-small">
                          Paid: {formatCurrency(emi.partiallyPaidAmount)} <br />
                          Remaining: {formatCurrency(emi.emiBalance)}
                        </div>
                      )}

                      {/* last payment details */}
                      {isPaid && emi.lastPaidAmount && (
                        <div className="emi-small">
                          Last Paid: {formatCurrency(emi.lastPaidAmount)}
                        </div>
                      )}

                      {/* outstanding */}
                      <div className="emi-small">
                        Outstanding: {formatCurrency(emi.outstanding)}
                      </div>
                    </td>

                    <td>{emi.paidDate ? formatDate(emi.paidDate) : "-"}</td>

                    {/* ACTIONS */}
                    <td>
                      {isPaid ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>✔ Paid</span>
                      ) : (
                        <div className="emi-actions">
                          <button className="btn-full" onClick={() => handlePayClick(emi)}>
                            Pay 
                          </button>

                          {/* <button className="btn-partial" onClick={() => handlePayClick(emi, "partial")}>
                            Partial
                          </button> */}

                          {/* <button className="btn-advance" onClick={() => handlePayClick(emi, "advance")}>
                            Advance
                          </button> */}
                        </div>
                      )}
                    </td>

                    {/* Slip */}
                    <td>
                      {isPaid ? (
                        // <div classname="slip-action-button-grploan">
                        //   <button
                        //     className="btn-print"
                        //     onClick={() => generateEmiSlipPDF(emi, i + 1)}
                        //   >
                        //     Download
                        //   </button>
                        //   <button
                        //     className="btn-preview"
                        //     onClick={() => previewEmiSlipPDF(emi, i + 1)}
                        //   >
                        //     Preview
                        //   </button>
                        // </div>
                         <button
                            className="grouploanemidetails-emi-reciept"
                            onClick={() =>
                              navigate("/grouploan/grouploanreport/GroupLoanEmiDetails/reciept", {
                                state: {emi,loan,nextEmi},
                              })
                            }
                          >
                            Receipt
                          </button>
                      ) : (
                        <span style={{ color: "gray" }}>After Payment</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>

          </table>
        )}
      </div>

      {/* Payment Modal */}
      {showModal && (
        <div className="viewemiloandata-modal-overlay">
          <div className="viewemiloandata-modal">
            <h3>
              {paymentData.type === "full" &&
                `Pay Full EMI (No: ${selectedEmi?.emiNumber})`}
              {paymentData.type === "partial" &&
                `Partial Payment (No: ${selectedEmi?.emiNumber})`}
              {paymentData.type === "advance" &&
                `Advance EMI Payment (No: ${selectedEmi?.emiNumber})`}
            </h3>

            {paymentData.type === "partial" && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Note: Partial payment accepted. Remaining amount will stay
                pending.
              </p>
            )}

            <label>
              Amount:
              <input
                type="number"
                value={paymentData.amountPaid}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    amountPaid: e.target.value,
                  })
                }
              />
            </label>

            <label>
              Mode:
              <select
                value={paymentData.paymentMode}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentMode: e.target.value,
                  })
                }
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="UPI">UPI</option>
                <option value="NetBanking">Net Banking</option>
              </select>
            </label>

            <label>
              Date:
              <input
                type="date"
                value={paymentData.paymentDate}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentDate: e.target.value,
                  })
                }
              />
            </label>

            <label>
              Remark:
              <input
                type="text"
                value={paymentData.remark}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    remark: e.target.value,
                  })
                }
              />
            </label>

            <div className="modal-actions">
              <button onClick={() => setShowModal(false)}>Cancel</button>

              <button
                onClick={handleSubmitPayment}
                disabled={submitting}
              >
                {submitting ? "Processing..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Preview Modal */}
      {showPreview && previewUrl && (
        <div className="viewemiloandata-modal-overlay">
          <div
            className="viewemiloandata-modal"
            style={{ width: "80%", height: "90%" }}
          >
            <h3>Slip Preview</h3>

            <iframe
              src={previewUrl}
              style={{
                width: "100%",
                height: "80%",
                border: "none",
              }}
            />

            <div className="modal-actions">
              <button
                onClick={() => {
                  setShowPreview(false);
                  URL.revokeObjectURL(previewUrl);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="account-ledger-list-pagination-section">
            <div className="account-ledger-list-pagination-div">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ⬅ Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next ➡
              </button>
            </div>
         </div>

      {/* Footer */}
      <footer className="viewemiloandata-footer">
        <p>© 2025 {company?.name || "TechVision Finance"} Pvt. Ltd.</p>
        <p>{company?.tagline || "Empowering Dreams"}</p>
      </footer>

      
    </div>
  );
};

export default GroupLoanEmiDetails;
